export const companyAddress = {
  type: 'string',
  minLength: 0,
  maxLength: 2_048,
};
